import React, { useState, Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import { withRouter } from "react-router";

import apiResponse from "../../../../../services/apiResponse";

import DetailBloc from "./Blocs/DetailBloc";
// import PegawaiSideBar from '../../../GlobalComponents/PegawaiSidebar';
import moment from "moment";

class IndexView extends Component {
  detailBloc = new DetailBloc();

  constructor(props) {
    super(props);
    this.state = {};
  }

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              {/* <PegawaiSideBar active="riwayatjabatan"/> */}

              <Card className="">
                <CardBody>
                  <CardTitle>Detail Rwiayat Angka Kredit</CardTitle>
                  <CardSubtitle className="mb-3">
                    Informasi Detail Rwiayat Angka Kredit
                  </CardSubtitle>
                  <hr />

                  <Row className="mb-3">
                    <label className="col-md-3">Nama</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_full_name !== ""
                            ? this.state.detail.employee_full_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Jabatan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_current_position_name !==
                          ""
                            ? this.state.detail.employee_current_position_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">No SK</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_score_decree_number !== ""
                            ? this.state.detail.credit_score_decree_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tanggal SK</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_score_decree_date !== ""
                            ? this.dateParse(
                                this.state.detail.credit_score_decree_date
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Bulan Mulai Penilaian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_score_month_start !== ""
                            ? this.state.detail.credit_score_month_start
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Bulan Selesai Penilaian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_score_month_end !== ""
                            ? this.state.detail.credit_score_month_end
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Tahun Mulai Penilaian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_score_year_start !== ""
                            ? this.state.detail.credit_score_year_start
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Tahun Selesai Penilaian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_score_year_end !== ""
                            ? this.state.detail.credit_score_year_end
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Kredit Penunjang Baru</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_score_secondary !== ""
                            ? this.state.detail.credit_score_secondary
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Kredit utama Baru</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_score_primary !== ""
                            ? this.state.detail.credit_score_primary
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Total Kredit Baru</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_score_total !== ""
                            ? this.state.detail.credit_score_total
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Dokumen SK</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.document !== null ? (
                            <a
                              target={"_blank"}
                              className="btn btn-sm btn-success"
                              href={this.state.detail.document.documents_path}
                            >
                              Download <i className="fa fa-download ms-1"></i>
                            </a>
                          ) : (
                            "-"
                          )}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Status</label>
                    <Col md="9">
                      {this.state.detail ? (
                        this.state.detail.credit_score_status === 1 ? (
                          <label className="badge rounded-pill bg-soft-warning font-size-12">
                            Menunggu Approval Admin
                          </label>
                        ) : this.state.detail.credit_score_status === 2 ? (
                          <label className="badge rounded-pill bg-soft-success font-size-12">
                            Disetujui
                          </label>
                        ) : (
                          <label className="badge rounded-pill bg-soft-danger font-size-12">
                            Ditolak
                          </label>
                        )
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <br />
                  <br />

                  <Row className="mb-3">
                    <Col md="3"></Col>
                    <Col md="9">
                      <Link
                        to="/kepegawaian/riwayat_angkakredit.html"
                        className="waves-effect"
                      >
                        <Button color="danger">
                          <i className="uil-arrow-left"></i> Kembali
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
